<template>
  <div class="upload-wrapper">
    <el-upload v-show="unFull"
      id="upload"
      ref="upload"
      :auto-upload="action !== '' && autoUpload"
      :action="action"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      :on-progress="handleProgressFile"
      :on-remove="handleRemoveFile"
      :accept="accept.join(',')"
      :before-upload="beforeUpload"
      :show-file-list="false"
      :on-change="handleFileListChange"
      :headers="uploadHeaders"
      multiple
      drag
    >
      <i class="el-icon-circle-plus"></i>
      <div class="el-upload__text">
        <slot name="upload-text"></slot>
      </div>
    </el-upload>
    <template v-for="(file, index) in preFileList">
      <div :key="index" class="file-wrapper upload-status">
        <video v-if="isVideo(file) && file.raw.url" :key="file.uid" muted>
          <source :src="file.raw.url" type="video/webm;codecs=vp8, vorbis"/>
          <source :src="file.raw.url" :type="file.raw.type" />
        </video>
        <div v-else-if="isImage(file) && file.raw.url" :key="file.uid" :style="{backgroundImage: `url(\'${file.raw.url}\')`}" class="image"></div>
        <div v-else class="file-icon-wrapper">
          <i class="el-icon-folder-checked"></i>
        </div>
        <div :class="['upload-progress-wrapper', file.hasOwnProperty('response') ? 'percentage-finished' : 'percentage-unfinished']" >
          <div v-if="file.percentage" class="upload-progress">
            <el-progress :percentage="file.percentage" :show-text="false"></el-progress>
            <span class="percentage">{{file.percentage.toFixed(0)}}%</span>
          </div>
          <div v-if="!options.disabledDeleted" class="button-wrapper">
            <el-button type="primary" icon="el-icon-delete" circle @click="handleRemoveFile(file)"></el-button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'upload-media',

  props: {
    accept: {
      type: Array,
      required: false,
      default: () => {
        return ['*/*']
      }
    },

    maxSize: {
      type: Number,
      required: false,
      default: 0
    },

    action: {
      type: String,
      required: false,
      default: ''
    },

    limit: {
      type: Number,
      required: false,
      default: null
    },

    header: {
      type: Object,
      required: false,
      default: () => ({})
    },

    initFileList: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },

    autoUpload: {
      type: Boolean,
      required: false,
      default: true
    },

    errMsg: {
      type: Object,
      required: false,
      default: () => ({
        overSize: '',
        overType: '',
        overLimit: ''
      })
    },

    options: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  data() {
    return {
      fileList: [],
      preFileList: [],
      delFileList: []
    }
  },

  computed: {
    isuNotExceed () {
      return isNaN(this.limit) || this.preFileList.length <= this.limit
    },

    unFull () {
      return isNaN(this.limit) || this.preFileList.length < this.limit
    },

    uploadHeaders () {
      return Object.assign({
        token: this.$store.state.user ? this.$store.state.user.token : ''
      }, this.header)
    }
  },

  created () {
    console.log(this.initFileList)
    this.fileList = [...this.initFileList]
    this.preFileList = [...this.initFileList]
  },

  methods: {
    // 上传之前
    beforeUpload (file) {
      const isLtMaxSize = this.maxSize === 0 || file.size < this.maxSize
      const isAcceptType = this.isAcceptType(file)

      if (!isLtMaxSize) {
        this.$message.error( this.errMsg.overSize || '上传文件大小超出限制!' )
      } else if (!isAcceptType) {
        this.$message.error( this.errMsg.overType || '上传文件类型不支持!' )
      } else if (!this.isuNotExceed) {
        this.$message.error( this.errMsg.overLimit || '上传文件数量超出限制!' )
      } else {
        file.url = this.getObjectURL(file)
        this.preFileList.push({})
      }

      return isLtMaxSize && isAcceptType && this.isuNotExceed
    },

    isAcceptType (file) {
      let result = this.accept.includes(file.type) || this.accept.includes('*') || this.accept.includes('*/*')
      if (!result) {
        const nameArr = file.name.split('.')
        if (nameArr.length > 0) {
          result = this.accept.includes(`.${nameArr.pop()}`)
        }
      }
      return result
    },

    // 上传成功
    handleUploadSuccess({ data, code, msg }, file, fileList) {
      if (code === 200) {
        if (!this.delFileList.includes(file.uid)) {
          this.fileList.push(file)
          setTimeout(() => this.refreshPreFileList(file.uid), 300)
          this.$emit('change', this.fileList)
        }
      } else {
        this.$message.error('上传失败')
      }
    },

    // 获取url
    getObjectURL(file) {
      var url = null
      if (window.createObjectURL !== undefined) {
        url = window.createObjectURL(file)
      } else if (window.URL !== undefined) {
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },

    refreshPreFileList (uid) {
      this.preFileList = this.preFileList.map(ob => {
        ob.uid === uid && (ob.isFinished = true)
        return ob
      })
    },

    // 处理上传进度
    handleProgressFile(event, file, fileList) {
      this.preFileList = fileList.filter(
        ob => !this.delFileList.includes(ob.uid)
      )
    },

    // 上传失败
    handleUploadError(err, file, fileList) {
      this.handleRemoveFile(file)
      this.$message.error('上传失败')
    },

    // 移除文件
    handleRemoveFile (file) {
      if (file.percentage < 100) {
        this.$refs.upload && this.$refs.upload.abort(file)
      }
      this.delFileList.push(file.uid)
      this.fileList = this.fileList.filter(ob => !this.delFileList.includes(ob.uid))
      this.preFileList = this.preFileList.filter(ob => !this.delFileList.includes(ob.uid))
      this.$emit('change', this.fileList)
    },

    handleFileListChange (file, fileList) {
      if (this.action === '' || !this.autoUpload) {
        if (this.beforeUpload(file.raw)) {
          this.fileList.push(file)
          this.preFileList = fileList.filter(
            ob => !this.delFileList.includes(ob.uid)
          )
          this.$emit('change', this.fileList)
        } else {
          this.handleRemoveFile(file)
        }
      }
    },

    isVideo (file) {
      return file.raw && /video\/[0-9A-z]+/.test(file.raw.type)
    },

    isImage (file) {
      return file.raw && /image\/[0-9A-z]+/.test(file.raw.type)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-wrapper {
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
  overflow: auto;
  height: 100%;
  width: 100%;
}

/deep/ .el-upload {
  margin-right: 10px;
  height: 146px;
  margin-bottom: 5px;

  &.el-upload--picture-card {
    width: 202px;
    margin-right: 10px;
  }

  .el-upload-dragger {
    width: 200px;
    height: 146px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #fafafa;

    .el-icon-circle-plus {
      font-size: 32px;
      color: #3f73d9;
    }

    .el-upload__text {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      line-height: 20px;
    }

    p {
      margin: 0;
      color: #c3c3c3;
    }
  }
}

.file-wrapper {
  width: 200px;
  height: 146px;
  position: relative;
  font-size: 12px;
  margin-bottom: 5px;
  margin-right: 10px;

  .image,
  video {
    background-color: #000;
    width: 100%;
    height: 100%;
  }

  .image {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .upload-progress-wrapper {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 2;

    .upload-progress {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .el-progress {
        width: 100%;
        margin: 0 10px;
        flex: 1;
      }

      .percentage {
        position: absolute;
        transform: translate(0, 1rem);
        color: blue;
      }
    }

    .button-wrapper {
      width: 100%;
      height: 100%;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      z-index: 3;
      display: none;
      position: absolute;
      top: 0;
      margin: 0;
      background-color: rgba(255, 255, 255, 0.3);

      .el-button {
        width: unset;
        font-size: 18px;
        border: 5px solid rgba(255, 255, 255, 0.3);
      }
    }

    &:hover .button-wrapper {
      display: flex;
    }
  }

  .percentage-unfinished,
  [class*=" percentage-"]:hover,
  [class^=percentage-]:hover {
    background-color: rgba(233, 233, 233, 0.8);
  }

  .percentage-finished {
    .upload-progress {
      display: none;
    }
  }
}

.file-icon-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 80px;
}
</style>
